/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component }  from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Menu from './Components/Menu';
import Slideshow from './Components/SlideShow';
import 'bootstrap/dist/css/bootstrap.min.css';
import Inicio from './Components/Sections/Inicio';
import Descargas from './Components/Sections/Descargas';
 
import Prevencion_Info from './Components/Sections/Prevencion_Info';
import Prevencion_Desc from './Components/Sections/Prevencion_Desc';
import Prevencion_Mat from './Components/Sections/Prevencion_Mat';

import Covid_Info from './Components/Sections/Covid_Info';
import Covid_Desc from './Components/Sections/Covid_Desc';

import Novedades from './Components/Sections/Novedades';
import NovedadesConteiner from './Components/Novedades/NovedadesConteiner';

import FFEP from './Components/Sections/FFEP';
import Nosotros from './Components/Sections/Nosotros';
import Autoridades from './Components/Sections/Autoridades';
import Footer from './Components/Footer';
import Blanco from './Components/Blanco';
import Denuncias from './Components/Sections/Denuncias';
import Prestaciones from './Components/Sections/Prestaciones';
import Normativas from './Components/Sections/Normativas';
import PreguntasFrecuentes from './Components/Sections/PreguntasFrecuentes';
import Sucursales from './Components/Sections/Sucursales';
import Reclamos from './Components/Sections/Reclamos';
import Poliza from './Components/Sections/Poliza';
import ScrollToTop from './Components/Sections/ScrollToTop';
import Nosotros_Quienes from './Components/Sections/Nosotros_Quienes';
import Nosotros_Porque from './Components/Sections/Nosotros_Porque';
import Nosotros_Mision from './Components/Sections/Nosotros_Mision';
import Fraude from './Components/Sections/Fraude';

import Politicas from './Components/Sections/Politicas';
import Terminos from './Components/Sections/Terminos';
import Capacitacion from './Components/Sections/Capacitacion.js';

import NuestraRed from './Components/NuestraRed/NuestraRed.js';

import Usuario from './Components/Sections/Usuarios.js';

import WhatsApp from './Components/WhatsApp.js';

import TagManager from 'react-gtm-module';

export class App extends Component {

    /*componentDidMount(){

        const tagManagerArgs = {
            gtmId: 'AW-10795233028'
        }
        TagManager.initialize(tagManagerArgs)
       
    }*/
    
    render() {
              return (
            <Router>
                <Menu/>
                <ScrollToTop/>
                <Route path="/INICIO" exact component={Blanco}/>
                <Route path="/" exact component={Blanco}/>
                <Route path="/DESCARGAS" component={Blanco}/>
                <Route path="/NOSOTROS" component={Blanco}/>
                <Route path="/AUTORIDADES" component={Blanco}/>
                <Route path="/NOVEDADES" component={Blanco}/>
                <Route path="/FFEP" component={Blanco}/>
                <Route path="/PRESTACIONES" component={Blanco}/>
                <Route path="/DENUNCIAS" component={Blanco}/>
                <Route path="/NORMATIVA" component={Blanco}/>
                <Route path="/PREGUNTASFRECUENTES" component={Blanco}/>
                <Route path="/SUCURSALES" component={Blanco}/>
                <Route path="/RECLAMOS" component={Reclamos}/>
                <Route path="/POLIZA" component={Blanco}/>
                <Route path="/NuestraRed" component={Blanco}/>
                
                <Route path="/CAPA" component={Capacitacion}/>

                <Route path="/NOSOTROS_QUIENES" component={Blanco}/>
                <Route path="/NOSOTROS_PORQUE" component={Blanco}/>
                <Route path="/NOSOTROS_MISION" component={Blanco}/>

                <Route path="/PREVENCION_INFO" component={Blanco}/>
                <Route path="/PREVENCION_DESC" component={Blanco}/>
                <Route path="/PREVENCION_MAT" component={Blanco}/>

                <Route path="/COVID_INFO" component={Blanco}/>
                <Route path="/COVID_DESC" component={Blanco}/>
               
                <Route path="/Politicas" component={Blanco}/>
                <Route path="/Terminos" component={Blanco}/>
                <Route path="/Fraude" component={Blanco}/>
                <Route path="/USUARIO" component={Blanco}/>
                <Route path="/NovedadesConteiner" component={Blanco}/>
                
                {/*<WhatsApp/>*/}
               
                {/*<Footer></Footer>*/}
            </Router>

           
        );
    }
}

export default App

